import { format } from 'date-fns';
import { cn } from '@/lib/utils';
import { toLocalDate } from '@/utils/temporal';
import type { HomeDeadline } from '@/hooks/useHomeDashboard';
import { stateLabel } from './deadline-widgets/shared';

export function DeadlineRow({
  deadline,
  onOpen,
}: {
  deadline: HomeDeadline;
  onOpen: (deadline: HomeDeadline) => void;
}) {
  const day = toLocalDate(deadline.date);
  return (
    <li>
      <button
        type="button"
        className={cn(
          'group flex w-full items-center gap-3 rounded-xl px-1 py-2.5 text-left',
          'transition-colors hover:bg-slate-50',
        )}
        onClick={() => onOpen(deadline)}
      >
        <div className="flex h-10 w-10 shrink-0 flex-col items-center justify-center rounded-lg bg-slate-50">
          <span className="text-[9px] font-semibold uppercase tracking-[0.12em] text-slate-400">
            {format(day, 'MMM')}
          </span>
          <span className="text-sm font-semibold tabular-nums leading-none text-slate-700">
            {format(day, 'd')}
          </span>
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-normal text-slate-700">{deadline.description}</p>
          <p className="mt-0.5 truncate text-xs text-slate-400">{deadline.matter_name}</p>
        </div>
        <span className="shrink-0 rounded-full bg-slate-50 px-2 py-0.5 text-[11px] font-medium text-slate-500">
          {stateLabel(deadline.state)}
        </span>
      </button>
    </li>
  );
}
